module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Kimberly Van Meter, Kimberly Van Meter\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Kimberly Van Meter started her writing career at the age of sixteen when she finished her first novel, typing late nights and early mornings, on her mother’s old portable typewriter. She received The Call in March 2006 with Harlequin Superromance and hasn't looked back since. She currently writes for Harlequin Romantic Suspense."), _c('Br', [_c('Br', [_vm._v("Kimberly and her three children make their home in the Central Valley of California.")])], 1)], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/gH2vQn/tc-custom/9781488010941.jpg?1722338487169",
      "alt": "This image is the cover for the book Tempted"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Tempted\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("One woman’s plans for her singles cruise getaway change when she lays eyes on the sexy Air Force veteran in the cabin next door in this steamy romance.")]), _c('br'), _c('br'), _c('i', [_vm._v("Her greatest temptation . . . ")]), _c('br'), _c('br'), _vm._v("As far as Harper Riley is concerned, attraction can’t be trusted. Money, on the other hand, lasts forever. Which is why Harper’s on a singles cruise for her latest: a wealthy widower who might just need a new wife. So why can’t she keep her eyes—or her dirty thoughts—off the ruggedly hot guy in the room next to hers?"), _c('br'), _c('br'), _vm._v("Of course, the charming ones are always broke, and Teagan Carmichael is both ridiculously charming and inexcusably broke. Worse still, there’s some serious heat sizzling between them. But Harper has too much riding on this trip to have her head turned by Mr. Deliciously-Sexy-But-Poor. She already knows that giving in to a little temptation can turn into a whole lot of trouble . . .\n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0